import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { sessionQuery } from "@/api/queries/session"
import { FullPageLoader } from "@/components/app/states"
import { AppShell } from "@/components/shell/app-shell"
import { NotFound } from "@/components/shell/route-states"
import { useTenantStore } from "@/stores/tenant"

/** Authenticated layout: requires a session, scopes the tab to a tenant, renders the shell. */
export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ context, location }) => {
    let session = await context.queryClient.ensureQueryData(sessionQuery())
    if (!session.authenticated) {
      throw redirect({ to: "/login", search: { redirect: location.href } })
    }
    // Keep this tab's tenant valid: fall back to the server's active tenant.
    const { tenantId, setTenantId } = useTenantStore.getState()
    const valid = session.tenants.some((x) => x.id === tenantId && !x.archived)
    if (!valid && session.active_tenant && tenantId !== session.active_tenant.id) {
      setTenantId(session.active_tenant.id)
      session = await context.queryClient.fetchQuery(sessionQuery())
    } else if (!valid && tenantId !== null && !session.active_tenant) {
      setTenantId(null)
    }
    return { session }
  },
  component: AppLayout,
  pendingComponent: FullPageLoader,
  notFoundComponent: NotFound,
})

function AppLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  )
}
